/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import * as actions from './CreditCard-Actions';

const initialState = {
    cardBrand: '',
};

const creditCardReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.loadCreditCardBrand().type:
            return {
                ...state,
                cardBrand: action.data,
            };
        default:
            return state;
    }
};

export default creditCardReducer;
